import type { PiDetailDto } from '@hisense/shared';
import { documentTotals } from './documentTotals';

/** One document snapshot for print and exports. Never substitute reference prices. */
export function piDocumentFacts(pi: PiDetailDto) {
  const hasDtd = pi.items.some(it => (it.dtdPrice ?? 0) > 0);
  const hasExw = pi.items.some(it => (it.exwPrice ?? 0) > 0);
  const hasUnderMoq = pi.items.some(it => (it.underMoqPrice ?? 0) > 0);
  const hasStyle = pi.items.some(it => it.customerStyleNo);
  const hasSubRef = pi.items.some(it => it.subRef);
  const hasColor = pi.items.some(it => it.color);
  const hasSize = pi.items.some(it => it.size);
  const hasMoq = pi.items.some(it => it.moq != null);
  const { lineSubtotal, base, discountPct, less, grand } = documentTotals(pi);
  const extraCols = [hasDtd, hasExw, hasUnderMoq].filter(Boolean).length;
  const totalColSpan = 5 + [hasStyle, hasSubRef, hasColor, hasSize, hasMoq].filter(Boolean).length + extraCols;
  return { hasDtd, hasExw, hasUnderMoq, hasStyle, hasSubRef, hasColor, hasSize, hasMoq,
    lineSubtotal, base, discountPct, less, grand, totalColSpan };
}

// eslint-disable-next-line no-control-regex -- CỐ Ý: lọc bỏ ký tự điều khiển trước khi gửi ra máy in tem / chứng từ. Đó chính là việc của dòng này.
export const piFileName = (piNo: string) => `proforma-invoice-${piNo.replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_')}`;
